module.exports = __webpack_public_path__ + "img/book16.4d3731cb.jpg";